import { createSelector } from 'reselect';

export const getDeepLinksState = (state) => state.deepLinks;

export const getQueuedDeepLink = createSelector(
    getDeepLinksState,
    (deepLinks) => deepLinks.queuedDeepLinkPath,
);
